module.exports = __webpack_public_path__ + "static/header-bg.0fc17a04.png";